/* eslint-disable array-callback-return */
import React from 'react';
import PlayerCard from './PlayerCard';

const Available = (props) => {
    const currentPick = props.currentPick;
    const players = props.players;
    const myTeam = Number(props.myTeam);
    const isAdmin = props.isAdmin;
    const isMyTurn = props.isMyTurn;
    const available = players.filter(x => x.team === 0);
    const availableList = available.map((player)=>{
        return  (
            <PlayerCard key={player.pid + '_available'} player={player} currentPick={currentPick} isAdmin={isAdmin} myTeam={myTeam} isMyTurn={isMyTurn}/>
        )
    })
    
    return  (
        <ol id="team0" data-team="0" className="team-list team0">
            {availableList}
        </ol>
    )
};

export default Available;